export default __webpack_public_path__ + "static/media/logo-conexa.c163bc74.png";